<template>
  <base-section id="Pegadaian">
    <v-container
            fluid
        >
            <v-layout
            align-center
            justify-center
            >
            <v-flex
                xs12
                sm8
                md4
            >
                <!-- <img src="../public/logo.png" width="97%"> -->
                <v-card class="elevation-12" outlined>
                <v-toolbar
                    color="primary"
                    dark
                    flat
                >
                    <v-toolbar-title>{{loading_title}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                        <v-icon>mdi-key</v-icon>
                </v-toolbar>
                <v-card-text>
                    <v-form v-model="form_pegadaian" ref="form" lazy-validation>
                    <v-text-field 
                        prepend-icon="mdi-file-document" 
                        v-model="policy_no" 
                        :rules="policy_no_rules"
                        required 
                        label="Nomor Polis"
                        type="text"
                        autofocus
                        @keydown.enter.prevent="Login">
                    </v-text-field>
                    </v-form>
                    <v-btn color="secondary" rounded block @click="Login">Cek Polis</v-btn>
                </v-card-text>
                <!-- <v-card-actions>
                    <span class="red--text">Version {{app_version}}</span>
                    <v-spacer></v-spacer>
                    <span @click="ForgotPassword">Forget Password</span>
                </v-card-actions> -->
                </v-card>
            </v-flex>
            </v-layout>
        </v-container>
        <v-dialog
          v-model="dialog"
          scrollable
          transition="dialog-transition"
        >
                <template>
                <v-card
                    class="mx-auto"
                    max-width="374"
                >
                    <v-img
                    height="250"
                    src="https://api.takafulumum.co.id/upload/files/takafulumum-wallpaper.jpg"
                    ></v-img>

                    <v-card-title> {{policy.fastflow_refid}} &bull; {{policy.fastflow_clientproductdesc}}</v-card-title>
                    <v-card-text>
                    <div class="my-4">
                        {{policy.fastflow_branchclientname}} &bull; {{policy.fastflow_insured}}
                    </div>
                    <div>Manfaat:
                    <ol>
                        <li>Santunan uang duka untuk ahli waris</li>
                        <li>Santunan kematian karena kecelakaan</li>
                        <li>Santunan cacat tetap</li>
                    </ol></div>
                    </v-card-text>
                    <v-card-actions @click="dialog = false"><v-spacer></v-spacer><v-icon color="primary" title="Verified by Takaful Umum">mdi-check-decagram</v-icon> <small>Verified by Takaful Umum</small></v-card-actions>
                </v-card>
                </template>
        </v-dialog>
        <v-snackbar 
            :timeout="snackbar.timeout"
            :color="snackbar.color"
            v-model="snackbar.dialog"
            rounded = "pill"
            bottom
            >
            {{ snackbar.text }}
            <template>
            <v-btn text @click.native="snackbar.dialog = false">Close</v-btn>
            </template>
        </v-snackbar>
  </base-section>
</template>

<script>
  export default {
    name: 'Login',
    data: () => ({
      check_login: null,
      dialog_forgot_password: false,
      //SnackBar
      snackbar: {
        dialog: false,
        color: 'success',
        text: '',
        timeout: 3000,
      },
      dialog: false,
      //Validation Form Users
      loading_title: '',
      feeds:[],
      form_pegadaian: true,
      policy_no: '',
      policy_no_rules: [
        v => !!v || 'No Polis is required'
      ],
      policy: {}
      
    }),
    provide: {
      heading: { align: 'center' },
    },
    created () {
      this.FirstLoad()
    },
    methods: {
        FirstLoad () {
            this.loading_title   = 'Pegadaian'
        },
        Login () {
            if (this.$refs.form.validate()) {
                this.CheckPegadaian(this.policy_no)
            }
        },
        CheckPegadaian(policy_no) {
            //Call API Users
            this.loading_title = 'Loading...'
            let formdata = new FormData()
            formdata.append('pegasus_no_kontrak', policy_no)
            this.$axios.post(this.$functions.SafeURL('apiPegasusList'), formdata, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                let feedback = response.data
                if (feedback.length > 0) {
                    if (feedback[0].feedback === 'Y') {
                        // Jika tipe RAHN maka buka link baru
                        if (feedback[0].pegasus_product_desc === "RAHN") {
                            // Ganti URL di bawah sesuai tujuan kamu
                            const targetURL = feedback[0].pegasus_url_document
                            window.open(targetURL, '_blank')
                            this.loading_title = 'Pegadaian'
                            return
                        }
                        this.dialog = true
                        this.policy.fastflow_refid = feedback[0].pegasus_no_kontrak
                        this.policy.fastflow_insured = feedback[0].pegasus_nama
                        this.policy.fastflow_clientproductdesc = feedback[0].pegasus_product_desc
                        this.policy.fastflow_branchclientname = feedback[0].pegasus_outlet
                    } else {
                        this.SnackBar(true, 'error', feedback[0].feedback, 3000)
                    }
                } else {
                    this.SnackBar(true, 'error', 'Nomor Polis `' + policy_no + '` tidak ditemukan', 3000)
                }
                this.loading_title = 'Pegadaian'
            })
            .catch(e => {
                this.loading_title = 'Pegadaian'
                this.SnackBar(true, 'error', e, 0)
            })
        },
        ForgotPassword () {
            this.dialog_forgot_password = true
            setTimeout(function(){
                document.getElementById('forgotpassword').focus()
            }, 500)
        },
        SnackBar (dialog, color, text, timeout) {
            this.snackbar.dialog  = dialog
            this.snackbar.color   = color
            this.snackbar.text    = text
            this.snackbar.timeout = timeout
        },
    },
}
</script>
